import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { NAV_LINKS } from "@/data/site";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page Not Found | Authentically Yours Property Services"
        description="The page you're looking for can't be found. Explore our cleaning and junk removal services in Greensboro, NC."
        path="/404"
      />
      <section className="min-h-[70vh] flex items-center bg-ink text-white">
        <div className="container-x text-center py-28">
          <p className="eyebrow text-blush">404</p>
          <h1 className="mt-4 text-5xl sm:text-6xl text-white">This page can't be found.</h1>
          <p className="mt-5 text-white/70 max-w-md mx-auto">
            The page you're looking for may have moved. Let's get you back on track.
          </p>
          <div className="mt-9 flex flex-wrap justify-center gap-3">
            <Link to="/" className="btn-primary btn-on-dark" data-testid="notfound-home">Back to Home</Link>
            <Link to="/free-estimate" className="btn-ghost btn-on-dark" data-testid="notfound-estimate">Get a Free Estimate</Link>
          </div>
          <nav aria-label="Site" className="mt-12 flex flex-wrap justify-center gap-x-6 gap-y-2">
            {NAV_LINKS.map((l) => (
              <Link key={l.to} to={l.to} className="text-sm text-white/60 hover:text-blush transition-colors">
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      </section>
    </>
  );
}
